import { GetRequest, PostRequest, Response, PutRequest } from "./payloads";

import { get as getBouncerUserSearch } from "./bouncer/v2/users/search";
import { get as getUserEcs } from "./wakanda/api/v1/users/:userId/ecs";
import { get as getBouncerUser } from "./bouncer/v2/users/:user_id";
import { post as userPermissionsCheck } from "./bouncer/v3/users/check-access";
import { get as getCmsProducts } from "./cms/api/es/products";
import { get as getSwatchInventory } from "./ragnarok/swatch/v1/inventory/search";
import { put as returnLendings } from "./ragnarok/swatch/v1/lendings/:inventoryId/return";
import { post as createLendings } from "./ragnarok/swatch/v1/lendings/create";
import { put as updateInventory } from "./ragnarok/swatch/v1/inventory/:inventoryId/update";
import { post as createSwatchInventory } from "./ragnarok/swatch/v1/inventory/create";
import { get as getSwatchProductsInventory } from "./ragnarok/swatch/v1/inventory/product/search";
import { get as getSwatchSkusInventory } from "./ragnarok/swatch/v1/inventory/sku/search";
import { post as requestOOSItem } from "./ragnarok/swatch/v1/out_of_stock";
import { get as getSwatchLendings } from "./ragnarok/swatch/v1/lendings/search";
import { get as fetchAllEcs } from "./wakanda/api/v1/experience-centers";
import { get as getMultipleBouncerUsers } from "./bouncer/v2/users";
import { post as getTemplatePdf } from "./template/api/v2/template/:templateName/pdf";
import { get as getCmsProductSKUs } from "./cmsapi/v2/products/:productId/skus";
import { get as getCmsProductDetails } from "./cmsapi/v2/products/:productId/getdetails";

function assertNever(x: never): never {
  throw new Error("Check not exhaustive");
}

export function get<R extends GetRequest>(req: R): Promise<Response<R>> {
  let request = req as GetRequest;
  let response: Promise<Response<R>>;

  switch (request.endpoint) {
    case "bouncer.v2.users.search":
      {
        let res = getBouncerUserSearch(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "wakanda.api.v1.users.:userId.ecs":
      {
        let res = getUserEcs(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "bouncer.v2.users.:user_id":
      {
        let res = getBouncerUser(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "cms.api.es.products":
      {
        let res = getCmsProducts(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.inventory.search":
      {
        let res = getSwatchInventory(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.inventory.product.search":
      {
        let res = getSwatchProductsInventory(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.inventory.sku.search":
      {
        let res = getSwatchSkusInventory(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.lendings.search":
      {
        let res = getSwatchLendings(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "wakanda.api.v1.experience-centers":
      {
        let res = fetchAllEcs(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "bouncer.v2.users":
      {
        let res = getMultipleBouncerUsers(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "cmsapi.v2.products.:productId.skus":
      {
        let res = getCmsProductSKUs(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "cmsapi.v2.products.:productId.getdetails":
      {
        let res = getCmsProductDetails(request);
        response = res as Promise<Response<R>>;
      }
      break;
    default:
      response = assertNever(request);
  }
  return response;
}

export function post<R extends PostRequest>(req: R): Promise<Response<R>> {
  let request = req as PostRequest;
  let response: Promise<Response<R>>;

  switch (request.endpoint) {
    case "ragnarok.swatch.v1.lendings.create":
      {
        let res = createLendings(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.inventory.create":
      {
        let res = createSwatchInventory(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.oos-requests":
      {
        let res = requestOOSItem(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "template.api.v2.template.:templateName.pdf":
      {
        let res = getTemplatePdf(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "bouncer.v3.users.check-access":
      {
        let res = userPermissionsCheck(request);
        response = res as Promise<Response<R>>;
      }
      break;
    default:
      response = assertNever(request);
  }
  return response;
}

export function put<R extends PutRequest>(req: R): Promise<Response<R>> {
  let request = req as PutRequest;
  let response: Promise<Response<R>>;

  switch (request.endpoint) {
    case "ragnarok.swatch.v1.lendings.:inventoryId.return":
      {
        let res = returnLendings(request);
        response = res as Promise<Response<R>>;
      }
      break;
    case "ragnarok.swatch.v1.inventory.:inventoryId.update":
      {
        let res = updateInventory(request);
        response = res as Promise<Response<R>>;
      }
      break;
    default:
      response = assertNever(request);
  }
  return response;
}

export { GetRequest, PostRequest, Response, PutRequest } from "./payloads";
